<template>
  <ViceBadge
    :icon="iconType"
    @click="togglePassword()"
    class="right-7 -mt-6 absolute cursor-pointer"
  ></ViceBadge>
</template>

<script>
import ViceBadge from '@/Components/Badges/ViceBadge.vue';

export default {
  components: {
    ViceBadge,
  },
  props: {
    password: {
      type: String,
    },
  },
  data() {
    return {
      iconType: null,
      fieldType: 'password',
    };
  },
  emits: ['fieldTypeChanged'],
  methods: {
    togglePassword() {
      this.fieldType = this.fieldType == 'password' ? 'text' : 'password';
      this.iconType = this.fieldType == 'password' ? 'EyeIcon' : 'EyeOffIcon';
      this.$emit('fieldTypeChanged', this.fieldType);
    },
    shouldShowIcon() {
      this.iconType =
        // eslint-disable-next-line no-nested-ternary
        this.password !== '' && this.fieldType == 'password'
          ? 'EyeIcon'
          : this.password !== '' && this.fieldType == 'text'
          ? 'EyeOffIcon'
          : '';
    },
  },
  watch: {
    password: {
      handler() {
        this.shouldShowIcon();
      },
    },
  },
};
</script>
